
import { EmptyStateLayout } from '@panwds/react-ui'
import { ztpIcon } from './assets'
const HeroBanner = ({ heading = '' }) => {
  return (
    <div className='tw-pb-5 tw-pt-5 tw-border-solid cm-border-[#DADBDB] dark:cm-border-[#242424] tw-bg-white dark:tw-bg-gray-1050'>
      <EmptyStateLayout heading={heading} graphic={<img className='cm-w-[200px]' alt={'logo'} src={ztpIcon} />} />
    </div>
  )
}
export default HeroBanner
